'use strict';
const _ = require('underscore');
const Backbone = require('backbone');
const SyncStateModel = require('system/domain/entity/sync-state');
const EditModeMixin = require('system/domain/entity/edit-mode-mixin');

var LinkMetaModel = Backbone.Model.extend({
    defaults: {
        creating: false,
        deleting: false,
        vendAt: null
    },

    initialize: function () {
        this.syncState = new SyncStateModel({
            state: SyncStateModel.States.synced});
        this.listenTo(this.syncState, 'change', function(state) {
            this.trigger('change:state', state);
        });
    },

    toJSON: function () {
        var j = LinkMetaModel.__super__.toJSON.call(this);
        delete j.id;
        return j;
    }
});

_.extend(LinkMetaModel.prototype, EditModeMixin);

module.exports = LinkMetaModel;



// WEBPACK FOOTER //
// ./system/domain/entity/link-meta.js